import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import form2 from '@/mixins/crud-form';
export default {
  mixins: [form2],
  data: function data() {
    return {
      api: {
        detail: 'CHARGE_CONFIGS_DETAIL',
        create: 'CHARGE_CONFIGS_CREATE',
        update: 'CHARGE_CONFIGS_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      var L = {
        prop: 'user_config_l',
        default: '',
        label: 'L',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_config_l,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_config_l", $$v);
              }
            }
          });
        }
      };
      var M = {
        prop: 'user_config_m',
        default: '',
        label: 'M',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_config_m,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_config_m", $$v);
              }
            }
          });
        }
      };
      var S = {
        prop: 'user_config_s',
        default: '',
        label: 'S',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_config_s,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_config_s", $$v);
              }
            }
          });
        }
      };
      var XL = {
        prop: 'user_config_xl',
        default: '',
        label: 'XL',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_config_xl,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_config_xl", $$v);
              }
            }
          });
        }
      };
      var XS = {
        prop: 'user_config_xs',
        default: '',
        label: 'XS',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_config_xs,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_config_xs", $$v);
              }
            }
          });
        }
      };
      return _toConsumableArray(1 == 1 ? [L, M, S, XL, XS] : 2 == 3 ? [L, M, S] : []);
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      // 洗衣店
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
    }
  }
};